<template>
  <!-- 优惠券列表弹层 -->
  <div class="choose-coupon">
    <exchange-coupon @success="success"></exchange-coupon>
    <div class="choose-title-text fs2">可用优惠券({{couponList.length}})</div>
    <coupon-item v-for="(item, i) in couponList" :key="i"
      :data="item"
      action="use"
      @confirm="confirm">
    </coupon-item>
    <div class="nolist tac mtw mbw fs1" v-if="couponList.length==0">
      ～暂无可用优惠券～
    </div>
  </div>
</template>

<script>
import CouponItem from '@/components/CouponItem';
import ExchangeCoupon from '@/components/CouponExchange';

export default {
  props: {
    targetType: {
      type: String
    },
    targetId: {},
    couponList: Array
  },
  components: {
    CouponItem,
    ExchangeCoupon
  },
  data() {
    return {
      active: 0,
      ableList: []
    }
  },
  methods: {
    confirm(data) {
      this.$emit('confirm', data);
    },
    success() {
      // this.getCoupons();
      this.$emit('changeCoupon')
    },
    // getCoupons() {
    //   getCouponsList(this.targetType, this.targetId).then(res => {
    //     let data = res.value;
    //     this.ableList = data.ok || [];
    //   })
    // }
  },
  mounted() {
    // this.getCoupons();
  }
}
</script>

<style lang="less">
.choose-coupon {
  width: 100%;  
}
.choose-coupon .choose-title-text {
  background: #fff;
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/chooseCoupon.vue